import type {ReactElement} from 'react'
import {section} from './sidebar-section.module.scss'

type Props = {
  children: ReactElement
}

export function SidebarSection({children}: Props) {
  return (
    <div className={section}>
      <ul className="list-unstyled">{children}</ul>
    </div>
  )
}
